var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.75,
    fill: "#808080",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80488 8C7.69944 8 7.59936 8.02596 7.50724 8.06879L12.1772 12.7268C12.3816 12.9309 12.6095 12.9311 12.8144 12.7268L17.4886 8.06387C17.3978 8.02247 17.2987 8 17.1951 8H7.80488ZM7.00838 8.80582C7.00293 8.85035 7 8.89705 7 8.9434V15.2328C7 15.7554 7.35898 16.1762 7.80488 16.1762H17.1951C17.641 16.1762 18 15.7554 18 15.2328V8.9434C18 8.89705 17.9971 8.85035 17.9916 8.80582L13.3384 13.4442C12.8561 13.925 12.1355 13.9258 11.6532 13.4442L7.00838 8.80582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/IconEmail.a9e00b9b233b485a89554ab670eb4780.svg";
export { ForwardRef as ReactComponent };